import type { UpdateUserGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateUserGroupDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateUserGroupInput = {
  Id: string;
  OriginalTimestamp: string;
  Name?: string;
  Email?: string | null;
  Description?: string | null;
  OwnerContributor?: boolean;
};

export const useUpdateUserGroup = createMutationHook({
  name: 'updateUserGroup',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userGroup.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateUserGroupInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
    trpc.frontend.userGroup.userGroupById.queryKey(),
  ],
  mapResponse: (): UpdateUserGroupMutation => ({
    update_user_group: {
      __typename: 'user_group_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateUserGroupDocument,
  graphqlVariables: (input: UpdateUserGroupInput) => ({ ...input }),
  evictFields: ['user_group', 'user_group_user'],
});
